import useLatestCouriersLocations from "@/shared/v2/queries/useLatestCouriersLocations";
import Map, { MapProps } from "./Map";

export interface MapWithCouriersProps extends MapProps {}

const MapWithCouriers = (props: MapWithCouriersProps) => {
  const { data: locations = [] } = useLatestCouriersLocations();
  return <Map {...props} couriers={locations} />;
};

export default MapWithCouriers;

// import { CourierGeoLocation } from "@/shared/v2/queries/interfacesV2";
// import { useEffect, useState } from "react";
// import Map, { MapProps } from "./Map";

// export interface MapWithCouriersProps extends MapProps {}

// const VESTIGING = {
//   lat: 51.9359272,
//   lon: 4.5812463,
// };

// const NUM_COURIERS = 5; // aantal couriers in de demo
// const MOVE_STEP = 0.01; // hoeveel ze elke update bewegen

// const MapWithCouriers = (props: MapWithCouriersProps) => {
//   const [couriers, setCouriers] = useState<CourierGeoLocation[]>([]);

//   useEffect(() => {
//     const initialCouriers: CourierGeoLocation[] = Array.from({
//       length: NUM_COURIERS,
//     }).map((_, i) => ({
//       account_id: `${i + 1}`,
//       account_name: `Courier ${i + 1}`,
//       lat: (VESTIGING.lat + Math.random() * 0.002 - MOVE_STEP).toString(),
//       lon: (VESTIGING.lon + Math.random() * 0.002 - MOVE_STEP).toString(),
//       order: "0",
//       time_stamp: new Date().toISOString(),
//       order_id: `${i + 100}`,
//       speed: `${Math.floor(Math.random() * 20 + 10)}`, // km/u
//       ride_id: `${i + 500}`,
//     }));

//     setCouriers(initialCouriers);

//     const interval = setInterval(() => {
//       setCouriers((prev) =>
//         prev.map((c) => ({
//           ...c,
//           lat: (
//             parseFloat(c.lat) +
//             (Math.random() - 0.5) * MOVE_STEP
//           ).toString(),
//           lon: (
//             parseFloat(c.lon) +
//             (Math.random() - 0.5) * MOVE_STEP
//           ).toString(),
//           time_stamp: new Date().toISOString(),
//         }))
//       );
//     }, 5000);

//     return () => clearInterval(interval);
//   }, []);

//   // const { data: locations = [] } = useLatestCouriersLocations();
//   return <Map {...props} couriers={couriers} />;
// };

// export default MapWithCouriers;
